import React from 'react';
import Svg from './Svg';

export default function File(props) {
  return (
    <Svg
      {...props}
      d="M851.45,240.8c9.6,9.6 17.7,22.2 24.3,37.8c6.6,15.6 9.9,30.6 9.9,45l0,577.8c0,13.8 -4.5,25.2 -13.5,34.2c-9,9 -20.4,13.8 -34.2,14.4l-675,0c-13.8,0 -25.2,-4.8 -34.2,-14.4c-9,-9.6 -13.8,-21 -14.4,-34.2l0,-802.8c0,-13.8 4.8,-25.2 14.4,-34.2c9.6,-9 21,-13.8 34.2,-14.4l450,0c13.2,0 27.9,3.3 44.1,9.9c16.2,6.6 28.8,14.7 37.8,24.3l156.6,156.6Zm-223.2,-122.4l0,189l189,0c-3,-10.2 -6.6,-17.1 -10.8,-20.7l-157.5,-157.5c-3.6,-4.2 -10.5,-7.8 -20.7,-10.8Zm193.5,767.7l0,-514.8l-208.8,0c-13.8,0 -25.2,-4.8 -34.2,-14.4c-9,-9.6 -13.8,-20.7 -14.4,-33.3l0,-209.7l-386.1,0l0,772.2l643.5,0Z"
    />
  );
}
